module.exports = __webpack_public_path__ + "static/media/members1.5f878fdb.jpg";